import React, { useEffect, useState } from "react";
import {
  Alert,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import TextInput from "../../../form-fields/text-input";
import SelectInput from "../../../form-fields/select-input";
import DateInput from "../../../form-fields/date-picker";
import DashBoardContainer from "../../../layout/dashboard-container";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import {
  getPrefilledTaxhead,
  getBasicPropertyDetails,
  generatePrefilledReceipt,
} from "../../../../services/generate-prefilled-receipt.js";
import { prefilledChallanValidationSchema } from "../../../../utils/validation-schema";
import { useFormik, FormikProvider, Form } from "formik";
import Loader from "../../../loader/loader";
import FormButtons from "../buttons";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import {
  getBankDetails,
  getModeOfPayments,
} from "../../../../services/generate-counter-receipt.js";
import { getCurrentDate, getErrorMsg } from "../../../../utils/helpers.js";
import {
  showToastError,
  showToastSuccess,
} from "../../../common/toastHelper.js";

const initialState = {
  propertyNumber: "",
  propertyName: "",
  propertyAddress: "",
  modeOfPayment: "",
  receiptDate: getCurrentDate(),
  chequeNumber: "",
  chequeDate: getCurrentDate(),
  bankName: "",
  remark: "",
  paidAmount: "",
  noOfBudgetHeads: [],
};

const PrefilledChallan = () => {
  const navigate = useNavigate();
  const lang = useSelector((state) => state.userDetails.lang);
  const [modeOfPayments, setModeOfPayments] = useState([]);
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isBankDisabled, setIsBankDisabled] = useState(true);
  const [error, setError] = useState("");
  const [noOfBudgetHeads, setNoOfBudgetHeads] = useState([]);
  const [budgetHeads, setBudgetHeads] = useState([{ label: "", value: "" }]);
  const [headsArray, setHeadsArray] = useState([]);

  const resetHeads = () => {
    window.location.reload();
    // setNoOfBudgetHeads([]);
    // setBudgetHeads([{ label: "", value: "" }]);
    // formik.setFieldValue("noOfBudgetHeads", "");
  };

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: prefilledChallanValidationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const { setValues } = formik;

  useEffect(() => {
    if (
      formik.values.modeOfPayment === 1 ||
      formik.values.modeOfPayment === 4
    ) {
      setIsBankDisabled(true);
    } else {
      setIsBankDisabled(false);
    }
  }, [formik.values, formik.errors]);

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    if (name === "propertyNumber" && value === "") {
      resetPropertyDetails();
    } else if (name === "noOfBudgetHeads" && value) {
      updateBudgetHeads(value);
    }
  };

  const resetPropertyDetails = () => {
    setValues({
      ...initialState,
      modeOfPayment: "",
      bankName: "",
    });
  };

  const updateBudgetHeads = (value) => {
    const headsArray = Array.from({ length: value }, (_, index) => index);
    setHeadsArray(headsArray);
  };

  const handleBlur = async (e) => {
    const { name, value } = e.target;
    if (name === "propertyNumber") {
      if (value && !formik?.errors?.propertyNumber) {
        try {
          setLoading(true);
          const receiptData = await getBasicPropertyDetails(value);
          setValues((prevValues) => ({
            ...prevValues,
            ...receiptData,
            modeOfPayment: "",
            bankName: "",
          }));

          const [modeOfPaymentsData, banksData, heads] = await Promise.all([
            getModeOfPayments(),
            getBankDetails(),
            getPrefilledTaxhead(),
          ]);

          setModeOfPayments(modeOfPaymentsData);
          setBanks(banksData);

          const listOfHeads = heads.map((item, index) => ({
            label: `${index + 1}`,
            value: index + 1,
          }));
          // console.log("!!listOfHeads", listOfHeads);
          setNoOfBudgetHeads(listOfHeads);

          const transformedArray = heads.map((obj) => ({
            value: obj.name,
            label: obj.name,
          }));
          setBudgetHeads(transformedArray);
          // console.log("!!transformedArray", transformedArray);
          setError("");
        } catch (error) {
          showToastError(getErrorMsg(error));
        } finally {
          setLoading(false);
        }
      } else if (!value) {
        resetPropertyDetails();
      }
    }
  };

  // const handleApiError = (error) => {
  //   const errorMsg =
  //     error?.response?.status === 400 && error?.response?.data?.code === "4001"
  //       ? error.response.data.message
  //       : "Something went wrong, please try again!";
  //   setError(errorMsg);
  // };

  const handleDelete = (indexToRemove) => {
    setHeadsArray((prevArray) =>
      prevArray.filter((_, index) => index !== indexToRemove)
    );
  };

  useEffect(() => {
    formik.setFieldValue("noOfBudgetHeads", headsArray.length || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headsArray]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const totalAmount = calculateTotalAmount();
    const budgetHeadRequestDTO = createBudgetHeadRequestDTO();

    if (totalAmount !== parseInt(formik.values.paidAmount)) {
      alert("Total amount not matching with heads");
      return;
    }

    const body = createRequestBody(totalAmount, budgetHeadRequestDTO);

    try {
      setLoading(true);
      const res = await generatePrefilledReceipt(body);
      showToastSuccess();
      navigate(
        `/PrintReceipt?receiptNo=${res.receiptno}&receiptType=${res.receipttype}`
      );
    } catch (error) {
      showToastError(getErrorMsg(error));
    } finally {
      setLoading(false);
    }
  };

  const calculateTotalAmount = () => {
    return headsArray.reduce(
      (acc, _, index) => acc + parseInt(formik.values[`paidAmount_${index}`]),
      0
    );
  };

  const createBudgetHeadRequestDTO = () => {
    return headsArray.map((_, index) => ({
      taxName: formik.values[`budgetHead_${index}`],
      amount: formik.values[`paidAmount_${index}`],
    }));
  };

  const createRequestBody = (totalAmount, budgetHeadRequestDTO) => {
    return {
      propertyCode: formik.values.propertyNumber,
      propertyName: formik.values.propertyName,
      propertyAddress: formik.values.propertyAddress,
      modeofPayment: formik.values.modeOfPayment,
      receiptDate: formik.values.receiptDate,
      chequeddDate: formik.values.chequeDate,
      chequeDDNo: formik.values.chequeNumber,
      bankName: formik.values.bankName,
      remark: formik.values.remark,
      paidAmount: totalAmount,
      budgetHeadRequestDTO: budgetHeadRequestDTO,
    };
  };

  return (
    <DashBoardContainer>
      {loading && (
        <Loader
          message={`Loading Property Number: ${formik.values.propertyNumber}`}
        />
      )}
      <FormikProvider value={formik}>
        <Form>
          {error && (
            <Alert
              sx={{
                padding: "0px",
                paddingLeft: "10px",
                paddingRight: "10px",
                marginTop: "15px",
              }}
              severity="error"
              onClose={() => setError("")}
            >
              {error}
            </Alert>
          )}
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.PREFILLEDCHALLAN[lang]} />
            <Grid>
              {renderFormFields(
                lang,
                handleFieldChange,
                handleBlur,
                formik,
                modeOfPayments,
                banks,
                isBankDisabled,
                noOfBudgetHeads
              )}
            </Grid>
          </Paper>
          {headsArray.length ? (
            <>
              <>
                {renderBudgetHeadsTable(
                  lang,
                  headsArray,
                  budgetHeads,
                  handleFieldChange,
                  handleDelete
                )}
              </>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmit}
                    resetForm={() => {
                      // formik.resetForm();
                      resetHeads();
                    }}
                    submitBtnLabel="Submit"
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Form>
      </FormikProvider>
    </DashBoardContainer>
  );
};

const renderFormFields = (
  lang,
  handleFieldChange,
  handleBlur,
  formik,
  modeOfPayments,
  banks,
  isBankDisabled,
  noOfBudgetHeads
) => (
  <>
    <GridRow>
      <FormLabel label={labels.PropertyNumber[lang]} required />
      <FormValue
        component={
          <TextInput
            name="propertyNumber"
            onChange={handleFieldChange}
            onBlur={handleBlur}
          />
        }
      />
    </GridRow>
    <GridRow>
      <FormLabel label={labels.PropertyName[lang]} required />
      <FormValue
        component={
          <TextInput name="propertyName" onChange={handleFieldChange} />
        }
      />
      <FormLabel label={labels.Address[lang]} required />
      <FormValue
        component={
          <TextInput name="propertyAddress" onChange={handleFieldChange} />
        }
      />
    </GridRow>
    <GridRow>
      <FormLabel label={labels.PaymentMode[lang]} required />
      <FormValue
        component={
          <SelectInput name="modeOfPayment" options={modeOfPayments} required />
        }
      />
      <FormLabel label={labels.ReceiptDate[lang]} />
      <FormValue component={<DateInput name="receiptDate" />} />
    </GridRow>
    <GridRow>
      <FormLabel label={labels.ChequeNumber[lang]} />
      <FormValue component={<TextInput name="chequeNumber" disabled={isBankDisabled} />} />
      <FormLabel label={labels.ChequeDate[lang]} />
      <FormValue component={<DateInput name="chequeDate" disabled={isBankDisabled} />} />
    </GridRow>
    <GridRow>
      <FormLabel label={labels.BankName[lang]} />
      <FormValue
        component={
          <SelectInput
            name="bankName"
            options={banks}
            disabled={isBankDisabled}
          />
        }
      />
      <FormLabel label={labels.Remark[lang]} />
      <FormValue component={<TextInput name="remark" />} />
    </GridRow>
    <GridRow>
      <FormLabel label={labels.PaidAmount[lang]} required />
      <FormValue component={<TextInput name="paidAmount" required />} />
      <FormLabel label={labels.noOfBudgetHeads[lang]} required />
      <FormValue
        component={
          <SelectInput
            name="noOfBudgetHeads"
            options={noOfBudgetHeads}
            onChange={handleFieldChange}
            required
          />
        }
      />
    </GridRow>
  </>
);

const renderBudgetHeadsTable = (
  lang,
  headsArray,
  budgetHeads,
  handleFieldChange,
  handleDelete
) => (
  <GridRow>
    <TableContainer>
      <Table size="small" sx={{ minWidth: 550 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ background: "#e6eaeb" }}>
            <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
              <b>{labels.SrNoShort[lang]}</b>
            </TableCell>
            <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
              <b>{labels.BudgetHeadName[lang]}</b>
            </TableCell>
            <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
              <b>{labels.Amount[lang]}</b>
            </TableCell>
            <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
              <b>{labels.Action[lang]}</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {headsArray.map((item, index) => (
            <TableRow key={index}>
              <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
                {index + 1}
              </TableCell>
              <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
                <SelectInput
                  name={`budgetHead_${index}`}
                  options={budgetHeads}
                  onChange={handleFieldChange}
                  required
                />
              </TableCell>
              <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
                <TextInput
                  name={`paidAmount_${index}`}
                  onChange={handleFieldChange}
                />
              </TableCell>
              <TableCell align="center" sx={{ border: "1px solid #e0e0e0" }}>
                <DeleteIcon
                  sx={{ color: "red", cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleDelete(index);
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </GridRow>
);

export default PrefilledChallan;
